import { Box, CloseButton, TextInput, TextInputProps } from '@mantine/core';

import LabelText, { LabelTextProps } from '../LabelText';

import styles from './TextInputWrapper.module.scss';

export interface TextInputWrapperProps extends TextInputProps {
  showLabel?: boolean;
  label?: string;
  labelProps?: Partial<LabelTextProps>;
  className?: string;
  showClear?: boolean;
  onClear?: () => void;
  required?: boolean;
}

const TextInputWrapper = ({
  showLabel = true,
  label,
  labelProps,
  className,
  showClear = false,
  onClear,
  required = false,
  ...rest
}: TextInputWrapperProps) => {
  const rightSection = () => {
    if (showClear) {
      return (
        <CloseButton
          aria-label="Clear input"
          onClick={onClear}
          style={{ display: rest.value ? undefined : 'none' }}
        />
      );
    }
    return null;
  };

  return (
    <Box>
      {showLabel && (label || labelProps?.label) && (
        <LabelText
          label={label || labelProps?.label || ''}
          required={required}
          variant="regular"
          {...labelProps}
        />
      )}
      <TextInput
        {...rest}
        rightSection={rightSection()}
        classNames={{
          input: `${styles.textInput} ${className || ''}`
        }}
      />
    </Box>
  );
};

export default TextInputWrapper;
